// extracted by mini-css-extract-plugin
export default {"correctnessLegend":"CorrectnessLegendSVG__correctnessLegend___OlM1I","correct":"CorrectnessLegendSVG__correct___c16Wk","incorrect":"CorrectnessLegendSVG__incorrect___hpwKX"};